import { Link } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import { hasAnyPermission } from "./auth/permissions";

const App = () => {
  const { user } = useAuth();
  const products = [
    {
      title: "Starters",
      link: "/starters",
      permissions: [
        "STARTERS_READ",
        "STARTERS_CREATE",
        "STARTERS_UPDATE",
        "STARTERS_DELETE",
      ],
    },
    {
      title: "Armatures",
      link: "/armatures",
      permissions: [
        "ARMATURES_READ",
        "ARMATURES_CREATE",
        "ARMATURES_UPDATE",
        "ARMATURES_DELETE",
      ],
    },
    {
      title: "Field Cases",
      link: "/field-cases",
      permissions: [
        "FIELD_CASES_READ",
        "FIELD_CASES_CREATE",
        "FIELD_CASES_UPDATE",
        "FIELD_CASES_DELETE",
      ],
    },
  ];
  const availableProducts = products.filter((product) =>
    hasAnyPermission(user, product.permissions),
  );
  return (
    <main className="mx-auto w-full max-w-screen-2xl px-4 py-10 sm:px-6 lg:py-14">
      <div className="mb-8 max-w-2xl">
        <p className="mb-2 text-sm font-semibold uppercase tracking-[0.16em] text-blue-700">
          Workspace
        </p>
        <h1 className="text-3xl font-semibold tracking-tight text-zinc-950">
          Product data
        </h1>
        <p className="mt-2 text-zinc-600">
          Choose a catalog to view and manage its data.
        </p>
      </div>
      <div className="grid max-w-5xl gap-4 md:grid-cols-2">
        <div className="contents">
          {availableProducts.map((product) => {
            return (
              <Link
                to={product.link}
                className="
                group block rounded-xl border border-zinc-200 bg-white p-6 shadow-sm transition hover:-translate-y-0.5 hover:border-blue-300 hover:shadow-md
                "
                key={product.link}
              >
                <span className="mb-3 block text-lg font-semibold text-zinc-950">
                  {product.title}
                </span>
                <span className="block text-sm text-zinc-600">
                  Browse and manage {product.title.toLowerCase()} catalog data.
                </span>
                <span className="mt-6 block text-sm font-medium text-blue-700 group-hover:text-blue-900">
                  Open catalog →
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </main>
  );
};

export default App;
